export default "__VITE_ASSET__OVTGFrUM__"